module.exports = __webpack_public_path__ + "img/AutumnSunset.8fb00a3c.gif";